import { Link } from '@tanstack/react-router';

import styled from '@mint-lib/styled';
import { Button } from '@mint-lib/tw-components';
import { cn } from '@mint-lib/tw-utils';

import Tooltip from '../Tooltip/Tooltip.jsx';
import { SidebarIconInterface } from './SideBar.jsx';

const SidebarButton = ({
  path,
  paths,
  title,
  icon: Icon,
  onClick,
}: SidebarIconInterface) => {
  if (!path && !paths) {
    throw new Error('Either path or paths must be provided');
  }
  return (
    <StyledTooltip title={title} placement="right" arrow>
      <Link
        onClick={onClick}
        to={path ?? paths?.[0]}
        activeOptions={{
          exact: false,
        }}
        preload="intent"
        preloadDelay={100}
      >
        {({ isActive }) => (
          <Button
            data-state={isActive ? 'active' : 'inactive'}
            icon
            variant="contained"
            size="large"
            className={cn(
              'bg-greyscale-grey70 p-0 hover:bg-greyscale-grey60!',
              'data-[state=active]:active data-[state=active]:bg-greyscale-grey50!',
            )}
          >
            <Icon aria-label={title} width="20" height="20" />
          </Button>
        )}
      </Link>
    </StyledTooltip>
  );
};

export default SidebarButton;

const StyledTooltip = styled(Tooltip)({
  '.MuiPopover-paper': {
    boxShadow: '0px 0px 8px rgba(34, 37, 43, 0.24)',
  },
});
